import Favorite from './Favorite';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

const ToggleFavoriteMutation = gql`
    mutation toggleFavorite($variantId: String!) {
        toggleFavorite(variantId: $variantId)
    }
`;

export default compose(
    graphql<any, any>(ToggleFavoriteMutation, {
        name: 'toggleFavorite'
    })
)(Favorite);



// WEBPACK FOOTER //
// ./src/pages/Favorite/index.ts